import { createStyles } from '../../core/withStyles';
const styles = (theme) => createStyles({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(2),
        marginLeft: theme.spacing(-2),
        color: theme.menu.foreground,
        '& > svg': {
            height: 24,
        },
    },
});
export default styles;
//# sourceMappingURL=MenuBack.styles.js.map